/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_126_TitleInputs */

const en_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epiphyllum`)
};

const ar_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإبيفيلوم`)
};

const de_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epiphyllum`)
};

const es_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cactus Orquídea`)
};

const fr_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epiphyllum`)
};

const it_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epiphyllum`)
};

const ja_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エピフィラム`)
};

const ko_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에피필룸`)
};

const pt_br_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dama da Noite`)
};

const ru_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эпифиллум`)
};

const th_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราชินีแห่งรัตติกาล`)
};

const tr_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atlas Çiçeği`)
};

const zh_cn_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`昙花`)
};

const zh_tw_tree_type_126_title = /** @type {(inputs: Tree_Type_126_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曇花`)
};

/**
* | output |
* | --- |
* | "Epiphyllum" |
*
* @param {Tree_Type_126_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_126_title = /** @type {((inputs?: Tree_Type_126_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_126_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_126_title(inputs)
	if (locale === "ar") return ar_tree_type_126_title(inputs)
	if (locale === "de") return de_tree_type_126_title(inputs)
	if (locale === "es") return es_tree_type_126_title(inputs)
	if (locale === "fr") return fr_tree_type_126_title(inputs)
	if (locale === "it") return it_tree_type_126_title(inputs)
	if (locale === "ja") return ja_tree_type_126_title(inputs)
	if (locale === "ko") return ko_tree_type_126_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_126_title(inputs)
	if (locale === "ru") return ru_tree_type_126_title(inputs)
	if (locale === "th") return th_tree_type_126_title(inputs)
	if (locale === "tr") return tr_tree_type_126_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_126_title(inputs)
	return zh_tw_tree_type_126_title(inputs)
});